import MainLayoutView from '@/generic/views/MainLayoutView';
import Language from '@/store/models/Language';
import { defineComponent, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default defineComponent({
    extends: MainLayoutView,
    setup() {
        const route = useRoute();
        const { params, query } = route;
        const store = useStore();

        onMounted(async () => {
            const language = new Language(store.getters.language);
            language.section = 'generic';
            language.reportAlias = null;
            language.instrumentAlias = null;
            language.knowledgeModelAlias = params.knowledgeModelAlias?.toString() ?? language.knowledgeModelAlias;
            language.languageCode = query.languageCode?.toString() ?? language.languageCode;

            await store.dispatch('setLanguage', language);
        });
    },
});
